import { currentAppBrand } from '@b2ag/app-brands'

/* ------- ROUTES ------- */

import { coreRoutes } from './core'
import { articlesRoutes } from './articles'
import { authRoutes } from './auth'
import { accountRoutes } from './my-account'
import { cartRoutes } from './cart'
import { checkoutRoutes, orderConfirmationRoute } from './checkout'
import { landingMainRoutes } from './landing'
import { legalsMainRoutes, legalsTechRoutes } from './legals'
import { membershipRoutes } from './membership'
import { listsRoutes } from './shopping-list'
import { signInRoutes } from './signup'
import { farmiAppApproRoutes } from './farmi-app-appro'
import { portalRoutes } from './portal'
import { previewRoutes } from './preview'
import { ordersRoutes } from './orders'
import { smagRoutes } from './smag'
import { needConverterRoutes } from './need-converter'
import { pdpRoutes } from './pdp'
import { currentProfileRoutes } from './current-profile'
import { getAliasForRouter } from '@b2ag/utils/src/i18n-routing'
import { flashOrderRoutes } from './flash-order'
import { plpRoutes } from './plp'

/* ------- PARENT - LAYOUT ------- */

const injectAliasForRoute = <T extends { path: string; alias?: string[] }>(route: T) => ({
  ...route,
  alias: getAliasForRouter(currentAppBrand, route.path, route.alias),
})

export default [
  ...authRoutes,
  ...signInRoutes.map(injectAliasForRoute),
  ...checkoutRoutes.map(injectAliasForRoute),
  ...smagRoutes.map(injectAliasForRoute),
  ...needConverterRoutes.map(injectAliasForRoute),
  ...legalsTechRoutes.map(injectAliasForRoute),
  ...articlesRoutes.map(injectAliasForRoute),
  ...cartRoutes.map(injectAliasForRoute),
  ...pdpRoutes.map(injectAliasForRoute),
  ...plpRoutes.map(injectAliasForRoute),
  ...legalsMainRoutes.map(injectAliasForRoute),
  ...accountRoutes.map(injectAliasForRoute),
  ...landingMainRoutes.map(injectAliasForRoute),
  ...farmiAppApproRoutes.map(injectAliasForRoute),
  ...membershipRoutes.map(injectAliasForRoute),
  ...listsRoutes.map(injectAliasForRoute),
  ...flashOrderRoutes.map(injectAliasForRoute),
  ...ordersRoutes.map(injectAliasForRoute),
  ...orderConfirmationRoute.map(injectAliasForRoute),
  ...currentProfileRoutes.map(injectAliasForRoute),
  ...coreRoutes.map(injectAliasForRoute),
  ...previewRoutes.map(injectAliasForRoute),
  ...portalRoutes.map(injectAliasForRoute), // ne pas le déplacer d'ici, sinon ça va écraser la route Home standard
]
